import { merge } from '../../helper';

import { light } from './light';
import { toggle } from './toggle';

// ----------------------------------------------------------------------------

function create(config: Record<string, any> = {}): Record<string, any> {
    // Default Config
    const defConfig: Record<string, any> = {
        type: 'light', // light, toggle
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    // If using light
    if (defConfig.type === 'light') {
        return light(defConfig);
    }

    // If using toggle
    return toggle(defConfig);
}

// ----------------------------------------------------------------------------

export { create };
